import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { OverlayBadge } from '@openng/optimus-ui/overlaybadge';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { ApplicationState } from '../../../../../shared/store/application-state';
import { MsgKeyModule } from '../../../../../shared/translate/msg-key.module';
import { NavigationQuery } from '../../../../store/navigation.reducer';

@Component({
	selector: 'bas-nav-basket',
	templateUrl: './basket.component.html',
	styleUrls: ['./basket.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		OverlayBadge,
		MsgKeyModule,
		MatIcon,
		Tooltip,
		RouterLink,
	],
})
export class BasketComponent {

	private readonly store = inject(Store<ApplicationState>);
	private readonly basket = this.store.selectSignal(NavigationQuery.getBasket);
	readonly count = computed(() => this.basket()?.shoppingcartsize ?? 0);
	readonly isEmpty = computed(() => !this.count());
	readonly tooltip = computed(() => this.isEmpty() ? 'basket.title.inactive' : 'text.link.tobasket');

}
